import React, { Fragment, useRef, useState } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from 'redux'
import SVG from "react-inlinesvg";
import classnames from 'classnames'
import PropTypes from 'prop-types'
import AnalyticsManager, { PageEventsTypes } from '@app/analytics/manager'

import { LandingPart } from '@app/components/shared/students/LandingPart'
import { Student } from '@app/models/users'
import * as studentActions from '@app/actions/students'

import PreviewTasks from './PreviewTasks'
import StartMainTourModal from '@app/components/shared/StartMainTourModal'
import timerIcon from '@src/images/student-tasks/timer';

const MainIntro = ({ student, global, route }) => {
  const classes = classnames(
    'page', 'student-tasks-page',
    'student-tasks-page--landing'
  )

  const modal = useRef(null)
  const [selectedTask, setSelectedTask] = useState(null)
  const dispatch = useDispatch()
  const boundStudentActions = bindActionCreators(studentActions, dispatch)
  const mainCards = useSelector(s => s.session?.user?._attributes?.participation?.olympiad?.main_cards);
  const starting = useSelector(s => s.students.participate?.starting)

  const handleTaskClick = (task) => {
    setSelectedTask(task)
    modal.current.open()
  }

  const handleTimerClick = () => {
    if (mainCards && mainCards.length > 0) {
      handleTaskClick(mainCards[0])
    }
  }

  const handleStart = async () => {
    await boundStudentActions.participate({ tour: 'main' })

    if (selectedTask) {
      AnalyticsManager.emitPageEvent(PageEventsTypes.OlympTaskClick, {
        task_name: selectedTask.names.en
      })

      route.history.push(`/students/tours/main/tasks/${selectedTask.id}`)
    }
  }

  const handleCancel = () => {
    setSelectedTask(null)
    modal.current.close()
  }

  return (
    <Fragment>
      <div className={classes}>
        <div className="student-tasks-page__inner">
          <div className="student-tasks-page__info">
            <div className="student-tasks-page__info-inner">
              Start when you're ready! You have 1 hour to&nbsp;solve the tasks.
              You only get 1 try and can't&nbsp;take breaks.
            </div>
          </div>
          <div className="student-tasks-page__timer">
            <div onClick={handleTimerClick}>
              <SVG src={timerIcon} />
            </div>
          </div>
          <div className="student-tasks-page__content-wrapper">
            <div className="student-tasks-page__tasks-wrapper">
              <PreviewTasks
                cards={mainCards}
                onTaskClick={handleTaskClick}
                className="main"
              />
            </div>
          </div>
        </div>
      </div>
      <StartMainTourModal
        modal={modal}
        onStart={handleStart}
        onCancel={handleCancel}
        starting={starting}
      />
      <LandingPart student={student} global={global} />
    </Fragment>
  )
}

MainIntro.propTypes = {
  student: PropTypes.instanceOf(Student).isRequired,
  global: PropTypes.object.isRequired,
  route: PropTypes.object.isRequired
}

export default MainIntro
